import React from "react";

const BannerIcon = ({ hover }: { hover?: boolean }) => {
  if (hover) {

    return (
      <svg width="142" height="55" viewBox="0 0 142 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_15299_29047)">
          <rect x="8.5" y="7" width="125" height="37" rx="4.5" stroke="#9EA7B6" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21 14.5C23.75 14.5 26 16.75 26 19.5C26 22.25 23.75 24.5 21 24.5C18.25 24.5 16 22.25 16 19.5C16 16.75 18.25 14.5 21 14.5ZM23.7241 17.7197C23.6038 17.5959 23.4059 17.5931 23.2822 17.7134L20.2857 20.6267L18.7178 19.1023C18.5941 18.982 18.3962 18.9848 18.2759 19.1086C18.1556 19.2323 18.1584 19.4301 18.2822 19.5504L20.0679 21.2866C20.1892 21.4045 20.3823 21.4045 20.5036 21.2866L23.7178 18.1616C23.8416 18.0413 23.8444 17.8434 23.7241 17.7197Z" fill="#1879B9" />
          <rect x="30" y="15.5" width="40" height="3" rx="1.5" fill="#DADEE6" />
          <rect x="30" y="20.5" width="69" height="3" rx="1.5" fill="#DADEE6" />
          <path d="M124.5 18.5L122 21L119.5 18.5" stroke="#9EA7B6" stroke-linecap="round" stroke-linejoin="round" />
          <rect x="32" y="26.5" width="30" height="10" rx="5" fill="#1879B9" />
        </g>
        <defs>
          <filter id="filter0_d_15299_29047" x="0" y="0.5" width="142" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15299_29047" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15299_29047" result="shape" />
          </filter>
          <clipPath id="clip0_15298_1190">
          <rect width="10" height="10" fill="white" transform="translate(16 14.5)" />
        </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg width="142" height="55" viewBox="0 0 142 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_15298_1190)">
        <rect x="8.5" y="7" width="125" height="37" rx="4.5" stroke="#9EA7B6" />
        <g clip-path="url(#clip0_15298_1190)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21 14.5C23.75 14.5 26 16.75 26 19.5C26 22.25 23.75 24.5 21 24.5C18.25 24.5 16 22.25 16 19.5C16 16.75 18.25 14.5 21 14.5ZM23.7241 17.7197C23.6038 17.5959 23.4059 17.5931 23.2822 17.7134L20.2857 20.6267L18.7178 19.1023C18.5941 18.982 18.3962 18.9848 18.2759 19.1086C18.1556 19.2323 18.1584 19.4301 18.2822 19.5504L20.0679 21.2866C20.1892 21.4045 20.3823 21.4045 20.5036 21.2866L23.7178 18.1616C23.8416 18.0413 23.8444 17.8434 23.7241 17.7197Z" fill="#9EA7B6" />
        </g>
        <rect x="30" y="15.5" width="40" height="3" rx="1.5" fill="#DADEE6" />
        <rect x="30" y="20.5" width="69" height="3" rx="1.5" fill="#DADEE6" />
        <path d="M124.5 18.5L122 21L119.5 18.5" stroke="#9EA7B6" stroke-linecap="round" stroke-linejoin="round" />
        <rect x="32.5" y="27" width="29" height="9" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
      </g>
      <defs>
        <filter id="filter0_d_15298_1190" x="0" y="0.5" width="142" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15298_1190" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15298_1190" result="shape" />
        </filter>
        <clipPath id="clip0_15298_1190">
          <rect width="10" height="10" fill="white" transform="translate(16 14.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BannerIcon;
